module.exports = __webpack_public_path__ + "static/media/toggle-up.8fd2520b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/toggle-up.svg
// module id = 775
// module chunks = 0